import axios, { AxiosInstance } from "axios";
import { API_URL } from "../../utils/globals";
import { GetCountriesListModel } from "../models/GetCountriesList";
import { GetNetworkListResponse } from "../models/GetNetworkList";
import { GetTokenListResponse } from "../models/GetTokenList";
import { GetCountryFromIPModel } from "../models/GetCountryFromIPModel";

class CommonApiService {
  private api: AxiosInstance;

  constructor() {
    this.api = axios.create({
      baseURL: API_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  public async getCountriesList(params?: {
    isEuropeFlow?: boolean;
  }): Promise<GetCountriesListModel> {
    const response = await this.api.get("/common/getCountriesList", {
      params,
    });
    return response.data;
  }

  public async getNetworksList(): Promise<GetNetworkListResponse> {
    const response = await this.api.get<GetNetworkListResponse>(
      "/transactions/getNetworksList",
    );
    return response.data;
  }

  public async getTokenList(): Promise<GetTokenListResponse> {
    const response = await this.api.get<GetTokenListResponse>(
      "/missing-transactions/tokens",
      { params: { isExchangePortal: 1 } },
    );
    return response.data;
  }

  public async getCountryFromIp(ip?: string): Promise<GetCountryFromIPModel> {
    try {
      const response = await this.api.get<GetCountryFromIPModel>(
        "/common/getCountryFromIp",
        {
          params: ip ? { ip } : {},
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const commonApiServices = new CommonApiService();
